import { useState, useEffect } from 'react'
import MobileMenu from './MobileMenu'
import RDMSBranding from './RDMSBranding'
import { responsiveStyles } from '../styles/responsiveStyles'

function PortalLayout({ 
  children, 
  session, 
  onLogout, 
  activeTab, 
  setActiveTab, 
  tabs, 
  unreadCount,
  portalTitle = "Portal",
  portalIcon = "🏢",
  onShowMessages
}) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const tabStyle = {
    background: 'rgba(255,255,255,0.08)',
    border: 'none',
    padding: '12px 18px',
    borderRadius: '10px',
    color: '#fff',
    fontSize: '14px',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    marginBottom: '8px'
  }

  const activeTabStyle = {
    ...tabStyle,
    background: '#2c7da0'
  }

  const messageButtonStyle = {
    position: 'relative',
    background: '#2c7da0',
    color: '#fff',
    border: 'none',
    padding: '12px 18px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '14px',
    textAlign: 'left',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '20px'
  }

  const badgeStyle = {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    background: '#dc2626',
    color: '#fff',
    borderRadius: '50%',
    minWidth: '20px',
    height: '20px',
    fontSize: '11px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 5px'
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Mobile Menu - Only shows on mobile */}
      <MobileMenu 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={tabs}
        onLogout={onLogout}
        unreadCount={unreadCount}
      />

      {/* Main Portal Container */}
      <div style={responsiveStyles.container}>
        {/* Desktop Sidebar */}
        <div style={responsiveStyles.sidebar}>
          <h2 style={{ color: '#fff', marginBottom: '30px' }}>{portalIcon} EstatesFlow</h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '20px' }}>{portalTitle}</p>
          
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={activeTab === tab.id ? activeTabStyle : tabStyle}
            >
              {tab.icon} {tab.label}
            </button>
          ))}
          
          {/* MESSAGES BUTTON */}
          <button onClick={onShowMessages} style={messageButtonStyle}>
            💬 Messages
            {unreadCount > 0 && <span style={badgeStyle}>{unreadCount}</span>}
          </button>
          
          <button onClick={onLogout} style={{ ...tabStyle, marginTop: '20px', background: '#dc2626' }}>
            🚪 Logout
          </button>
        </div>

        {/* Main Content Area - HEADER REMOVED */}
        <div style={responsiveStyles.main}>
          {children}
        </div>
      </div>

      {/* Footer */}
      <RDMSBranding showFooter={true} variant="compact" />
    </div>
  )
}

export default PortalLayout